import parsePhoneNumberFromString, {
    isValidPhoneNumber,
} from 'libphonenumber-js';
import { createLead, updateLeadStep } from '../../services/leadServices';
import { SCREEN } from '../../utils/constants';
import {
    emailOptin,
    procedures,
    providerServiceSummary,
    selectedCountry,
    selectedProcedures,
    setEmailOptin,
    setLeadTextId,
    setLeadInfo,
    sourceParam,
    visitorId,
    locations,
    selectedLocationId,
    businessName,
    smsConsentTransactional,
    smsConsentPromotional,
    termsAndPrivacyAccepted,
    setSmsConsentTransactional,
    setSmsConsentPromotional,
    setTermsAndPrivacyAccepted,
    a2pConsentEnabled,
    showSubscribedToOffersOption,
} from '../../utils/variables';
import {
    formatPhoneNumber,
    toggleCountriesAskQs,
    validatePhoneNumber,
} from '../actions/countryCodeActions';
import { toggleLoading } from '../actions/loading';
import { navigate, setSkipEndRedirect } from './movePages';
import { toastError } from '../../views/components/error';
import validator from 'validator';
import { isValidFullName } from '../actions/consultActions';
import { clearInputsAskQs } from '../actions/askQuestionActions';
import { loadConsultDetail } from '../../views/pages/consultSummary';
import { countryCodeListeners } from './countryCodeListeners';

var simpleConsentChecked = false;

export function askQuestionListeners() {
    /* On focus / blur - use addEventListener so we don't overwrite validation blur handlers */
    document.querySelectorAll('div.form-control input').forEach((i) => {
        i.addEventListener('focus', () => {
            const dataForm = i.getAttribute('id');
            document
                .querySelector(`div[data-form="${CSS.escape(dataForm)}"]`)
                ?.classList.add('on-focus');
        });
        i.addEventListener('blur', () => {
            const dataForm = i.getAttribute('id');
            document
                .querySelector(`div[data-form="${CSS.escape(dataForm)}"]`)
                ?.classList.remove('on-focus');
        });
    });

    /* on change inputs */
    const inputs = document.querySelectorAll('.askQuestion__container input');

    inputs.forEach((i) => {
        i.oninput = () => {
            const dataForm = i.getAttribute('id');
            document
                .querySelector(
                    `.askQuestion__container div[data-form="${CSS.escape(
                        dataForm
                    )}"]`
                )
                .classList.remove('invalid');
        };
    });

    document.querySelectorAll('.askQuestion__container textarea').forEach(
        (i) =>
            (i.oninput = () => {
                const dataForm = i.getAttribute('id');
                document
                    .querySelector(
                        `.askQuestion__container div[data-form="${CSS.escape(
                            dataForm
                        )}"]`
                    )
                    .classList.remove('invalid');
            })
    );

    /* on validate name */
    validateName();

    /* on format & validate phone number */
    formatAndValidatePhone();

    /* toggle country code phone number */
    toggleCountryCode();

    /* on change & validate email */
    validateEmail();

    /* on check email optin */
    onCheckEmailOptin();

    /* Update the consent text with business name */
    updateConsentText();

    /* Show/hide consent blocks based on a2p_consent_enabled setting */
    const a2pWrapper = document.querySelector('.askQuestion__container .sms-consent__wrapper');
    const simpleWrapper = document.querySelector('.askQuestion__container .sms-consent-simple__wrapper');
    if (a2pConsentEnabled) {
        if (a2pWrapper) a2pWrapper.style.display = '';
        if (simpleWrapper) simpleWrapper.style.display = 'none';
        const promotionalRow = document.querySelector('.askQuestion__container .sms-consent-promotional-row');
        if (promotionalRow) {
            promotionalRow.style.display = showSubscribedToOffersOption ? '' : 'none';
        }
        if (!showSubscribedToOffersOption) {
            setSmsConsentPromotional(false);
        }
    } else {
        if (a2pWrapper) a2pWrapper.style.display = 'none';
        if (simpleWrapper) simpleWrapper.style.display = '';
        // Passive consent — no checkbox needed, auto-grant on form display
        simpleConsentChecked = true;
        setSmsConsentTransactional(true);
        setTermsAndPrivacyAccepted(true);
    }

    /* on check SMS consent checkboxes (A2P compliance) */
    onCheckSmsConsentCheckboxes();
    /* on check Terms and Privacy Policy checkbox */
    onCheckTermsPrivacyCheckbox();
    toggleAskAQuestionButtonState();

    /* on click country code Ask a question button */
    countryCodeListeners();

    /* on click Continue (step 1): validate and go to step 2 or consult summary */
    document
        .querySelectorAll('.askQuestion__container .ask-question-continue__btn')
        .forEach((btn) => {
            btn.onclick = (e) => {
                e.preventDefault();
                if (btn.classList.contains('disabled')) return;
                let error = false;
                const step1FormControls = document.querySelectorAll(
                    '.askQuestion__container .ask-question-step-1 .form-control'
                );
                for (const i of step1FormControls) {
                    const dataForm = i.getAttribute('data-form');
                    const input = document.querySelector(
                        `.askQuestion__container div[data-form="${CSS.escape(
                            dataForm
                        )}"] #${CSS.escape(dataForm)}`
                    );
                    if (!input) continue;
                    if (
                        (input.getAttribute('id') === 'emailAskQuestion' &&
                            !validator.isEmail(input.value)) ||
                        (input.getAttribute('id') === 'phoneAskQuestion' &&
                            !isValidPhoneNumber(
                                input.value,
                                selectedCountry
                            )) ||
                        (input.getAttribute('id') === 'nameAskQuestion' &&
                            !isValidFullName(input.value)) ||
                        (locations?.length > 1 &&
                            input.getAttribute('id') === 'locationAskAQuestion' &&
                            !input.value)
                    ) {
                        i.classList.add('invalid');
                        error = true;
                    }
                }
                if (a2pConsentEnabled) {
                    // SMS consent checkboxes are optional — only terms & privacy is required
                    if (!termsAndPrivacyAccepted) {
                        const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');
                        if (termsPrivacyRow) termsPrivacyRow.classList.add('invalid');
                        error = true;
                    }
                } else {
                    if (!simpleConsentChecked) {
                        const simpleRow = document.querySelector('.askQuestion__container .sms-consent-simple-row');
                        if (simpleRow) simpleRow.classList.add('invalid');
                        error = true;
                    }
                }
                if (error) return;

                const container = document.querySelector('.askQuestion__container');
                const isBookAppointment = container?.classList.contains('book-appointment');

                if (isBookAppointment) {
                    const phone = parsePhoneNumberFromString(
                        document.querySelector('#phoneAskQuestion').value,
                        selectedCountry
                    );
                    const sourceSelectBooking = document.querySelector('#sourceAskQuestion');
                    const selectedSourceBooking = sourceSelectBooking?.value || sourceParam;

                    const data = {
                        full_name: document.querySelector('#nameAskQuestion').value,
                        phone: phone.number,
                        email: document.querySelector('#emailAskQuestion').value,
                        email_optin: emailOptin,
                        sms_consent_transactional: smsConsentTransactional,
                        sms_consent_promotional: smsConsentPromotional,
                        terms_and_privacy_accepted: termsAndPrivacyAccepted,
                        ...(selectedSourceBooking && { source: selectedSourceBooking }),
                        ...(visitorId && { visitor_id: visitorId }),
                        ...(selectedLocationId && { location_id: selectedLocationId }),
                    };
                    const proTemp = selectedProcedures.map((i) =>
                        procedures.find((j) => j.id === i)
                    );
                    loadConsultDetail(providerServiceSummary, proTemp);
                    setLeadInfo(data);
                    document.getElementById('consult-summary')?.focus();
                    navigate(SCREEN.CONSULT_SUMMARY);
                    return;
                }

                container?.classList.add('step-2');
                const submitBtn = document.querySelector('.askQuestion__container .ask-question__btn');
                if (submitBtn) {
                    submitBtn.classList.remove('disabled');
                    submitBtn.removeAttribute('disabled');
                }
            };
        });

    /* on click Ask a question button (step 2): validate question and submit */
    document
        .querySelectorAll('.askQuestion__container .ask-question__btn')
        .forEach((i) => {
            i.onclick = async (e) => {
                e.preventDefault();
                const questionInput = document.querySelector('#questionAskQuestion');
                const questionWrap = document.querySelector(
                    '.askQuestion__container div[data-form="questionAskQuestion"]'
                );
                if (!questionInput?.value?.trim()) {
                    if (questionWrap) questionWrap.classList.add('invalid');
                    return;
                }
                if (questionWrap) questionWrap.classList.remove('invalid');

                let error = false;
                const inputs = document.querySelectorAll(
                    '.askQuestion__container .form-control'
                );
                for (const fc of inputs) {
                    const dataForm = fc.getAttribute('data-form');
                    const input = document.querySelector(
                        `.askQuestion__container div[data-form="${CSS.escape(
                            dataForm
                        )}"] #${CSS.escape(dataForm)}`
                    );
                    if (
                        (input?.getAttribute('id') === 'questionAskQuestion' &&
                            !document.querySelector(
                                '.askQuestion__container.book-appointment'
                            ) &&
                            !input.value?.trim()) ||
                        (input?.getAttribute('id') === 'emailAskQuestion' &&
                            !validator.isEmail(input.value)) ||
                        (input?.getAttribute('id') === 'phoneAskQuestion' &&
                            !isValidPhoneNumber(
                                input.value,
                                selectedCountry
                            )) ||
                        (input?.getAttribute('id') === 'nameAskQuestion' &&
                            !isValidFullName(input.value)) ||
                        (locations?.length > 1 &&
                            input?.getAttribute('id') === 'locationAskAQuestion' &&
                            !input.value)
                    ) {
                        fc.classList.add('invalid');
                        error = true;
                    }
                }
                if (error) return;

                if (a2pConsentEnabled) {
                    // SMS consent checkboxes are optional — only terms & privacy is required
                    if (!termsAndPrivacyAccepted) {
                        const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');
                        if (termsPrivacyRow) termsPrivacyRow.classList.add('invalid');
                        return;
                    }
                } else {
                    if (!simpleConsentChecked) {
                        const simpleRow = document.querySelector('.askQuestion__container .sms-consent-simple-row');
                        if (simpleRow) simpleRow.classList.add('invalid');
                        return;
                    }
                }

                const phone = parsePhoneNumberFromString(
                    document.querySelector('#phoneAskQuestion').value,
                    selectedCountry
                );

                const sourceSelect = document.querySelector('#sourceAskQuestion');
                const selectedSource = sourceSelect?.value || sourceParam;

                const data = {
                    full_name: document.querySelector('#nameAskQuestion').value,
                    phone: phone.number,
                    message: document.querySelector('#questionAskQuestion').value,
                    email: document.querySelector('#emailAskQuestion').value,
                    email_optin: emailOptin,
                    sms_consent_transactional: smsConsentTransactional,
                    sms_consent_promotional: smsConsentPromotional,
                    terms_and_privacy_accepted: termsAndPrivacyAccepted,
                    ...(selectedSource && { source: selectedSource }),
                    ...(visitorId && { visitor_id: visitorId }),
                    ...(selectedLocationId && { location_id: selectedLocationId }),
                };

                if (
                    document.querySelector(
                        '.askQuestion__container.book-appointment'
                    )
                ) {
                    const proTemp = selectedProcedures.map((i) =>
                        procedures.find((j) => j.id === i)
                    );
                    loadConsultDetail(providerServiceSummary, proTemp);
                    delete data.message;
                    setLeadInfo(data);
                    document.getElementById('consult-summary')?.focus();
                    navigate(SCREEN.CONSULT_SUMMARY);
                    return;
                }

                toggleLoading(true);

                try {
                    const lead = await createLead(data);
                    setLeadTextId(lead.data.text_id);

                    await updateLeadStep(lead.data.id, 'question');

                    toggleLoading(false);

                    clearInputsAskQs();

                    // A question / Text Us submission is not a booking —
                    // thank_you_redirect_url must not fire here.
                    setSkipEndRedirect(true);
                    navigate(SCREEN.THE_END);
                } catch (err) {
                    toastError(err.response?.data?.message);

                    toggleLoading(false);
                }
            };
        });
}

function validateName() {
    const name = document.querySelector('#nameAskQuestion');
    const nameWrap = document.querySelector(
        `.askQuestion__container div[data-form="nameAskQuestion"]`
    );

    const applyNameValidation = (value) => {
        if (isValidFullName(value)) {
            nameWrap.classList.add('valid');
            nameWrap.classList.remove('invalid');
        } else {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
        }
    };

    name.oninput = (e) => {
        applyNameValidation(e.target.value);
    };

    name.addEventListener('blur', (e) => {
        applyNameValidation((e.target.value || '').trim());
    });
}

function formatAndValidatePhone() {
    const phone = document.querySelector('#phoneAskQuestion');
    const phoneWrapper = document.querySelector(
        '.askQuestion__container div[data-form="phoneAskQuestion"]'
    );

    phone.oninput = (e) => {
        const newValue = formatPhoneNumber(e.target.value, selectedCountry);
        phone.value = newValue;
        validatePhoneNumber(phoneWrapper, e.target.value);
    };

    phone.addEventListener('blur', () => {
        validatePhoneNumber(phoneWrapper, phone.value);
    });
}

function toggleCountryCode() {
    document.querySelector(
        `.phone__selected-code.${SCREEN.ASK_QUESTION}`
    ).onclick = () => toggleCountriesAskQs();
}

function validateEmail() {
    const email = document.querySelector('#emailAskQuestion');
    const emailWrap = document.querySelector(
        `.askQuestion__container div[data-form="emailAskQuestion"]`
    );

    const applyEmailValidation = (value) => {
        if (validator.isEmail(value)) {
            emailWrap.classList.add('valid');
            emailWrap.classList.remove('invalid');
        } else {
            emailWrap.classList.remove('valid');
            emailWrap.classList.add('invalid');
        }
    };

    email.oninput = (e) => {
        applyEmailValidation(e.target.value);
    };

    email.addEventListener('blur', (e) => {
        applyEmailValidation((e.target.value || '').trim());
    });
}

function onCheckEmailOptin() {
    const checkBox = document.querySelector(
        '.askQuestion__container .emailOptin__checkbox'
    );

    if(!checkBox) return;

    checkBox.onclick = () => {
        if (checkBox.classList.contains('is-checked')) {
            checkBox.classList.remove('is-checked');
            setEmailOptin(false);
        } else {
            checkBox.classList.add('is-checked');
            setEmailOptin(true);
        }
    };
}

function onCheckSmsConsentCheckboxes() {
    const transactionalCheckbox = document.querySelector(
        '.askQuestion__container .sms-consent-transactional-checkbox'
    );
    const promotionalCheckbox = document.querySelector(
        '.askQuestion__container .sms-consent-promotional-checkbox'
    );

    const transactionalRow = document.querySelector('.askQuestion__container .sms-consent-transactional-row');
    const promotionalRow = document.querySelector('.askQuestion__container .sms-consent-promotional-row');

    const handleTransactionalClick = (e) => {
        e.preventDefault();
        if (transactionalCheckbox) {
            transactionalCheckbox.classList.toggle('is-checked');
            setSmsConsentTransactional(transactionalCheckbox.classList.contains('is-checked'));
            transactionalRow?.classList.remove('invalid');
            toggleAskAQuestionButtonState();
        }
    };

    const handlePromotionalClick = (e) => {
        e.preventDefault();
        if (promotionalCheckbox) {
            promotionalCheckbox.classList.toggle('is-checked');
            setSmsConsentPromotional(promotionalCheckbox.classList.contains('is-checked'));
            toggleAskAQuestionButtonState();
        }
    };

    if (transactionalRow && transactionalCheckbox) {
        transactionalRow.style.cursor = 'pointer';
        transactionalRow.onclick = handleTransactionalClick;
        transactionalCheckbox.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTransactionalClick(e);
            }
        });
    }
    if (promotionalRow && promotionalCheckbox) {
        promotionalRow.style.cursor = 'pointer';
        promotionalRow.onclick = handlePromotionalClick;
        promotionalCheckbox.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handlePromotionalClick(e);
            }
        });
    }

    toggleAskAQuestionButtonState();
}

function onCheckTermsPrivacyCheckbox() {
    const termsPrivacyCheckbox = document.querySelector(
        '.askQuestion__container .terms-privacy-checkbox'
    );
    const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');

    const handleTermsPrivacyClick = (e) => {
        if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) {
            return;
        }
        e.preventDefault();
        if (termsPrivacyCheckbox) {
            termsPrivacyCheckbox.classList.toggle('is-checked');
            setTermsAndPrivacyAccepted(termsPrivacyCheckbox.classList.contains('is-checked'));
            termsPrivacyRow?.classList.remove('invalid');
            toggleAskAQuestionButtonState();
        }
    };

    if (termsPrivacyRow && termsPrivacyCheckbox) {
        termsPrivacyRow.style.cursor = 'pointer';
        termsPrivacyRow.onclick = handleTermsPrivacyClick;
        termsPrivacyCheckbox.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTermsPrivacyClick(e);
            }
        });
    }

    toggleAskAQuestionButtonState();
}

function toggleAskAQuestionButtonState() {
    const continueBtn = document.querySelector(
        '.askQuestion__container .ask-question-continue__btn'
    );
    if (continueBtn) {
        var consentMet = false;
        if (a2pConsentEnabled) {
            consentMet = termsAndPrivacyAccepted;
        } else {
            consentMet = simpleConsentChecked;
        }
        if (consentMet) {
            continueBtn.classList.remove('disabled');
            continueBtn.removeAttribute('disabled');
        } else {
            continueBtn.classList.add('disabled');
            continueBtn.setAttribute('disabled', 'disabled');
        }
    }
}

function updateConsentText() {
    const businessNameSpans = document.querySelectorAll(
        '.askQuestion__container .sms-consent-business-name'
    );
    const practiceNameText = businessName || '[Business Name]';
    businessNameSpans.forEach((span) => {
        span.textContent = practiceNameText;
    });
}
